import React from 'react';
import './ServicesSection.css';

const services = [
  {
    id: 1,
    title: 'VIP Kurs',
    desc: 'Küçük gruplarda, uzman eğitmenlerle kariyer hedeflerinize yönelik yoğun destek.',
  },
  {
    id: 2,
    title: 'İlkokul Etüt',
    desc: 'Okuma‑yazma ve temel matematik becerilerini pekiştiren etüt programı.',
  },
  {
    id: 3,
    title: '5‑6‑7. Sınıflar',
    desc: 'Ortaokula hazırlık odaklı, müfredat destekli konu anlatımı ve alıştırmalar.',
  },
  {
    id: 4,
    title: 'LGS Hazırlık',
    desc: 'LGS’ye yönelik deneme sınavları, soru çözüm teknikleri ve rehberlik.',
  },
  {
    id: 5,
    title: '9‑10‑11. Sınıflar',
    desc: 'Lise derslerine destek, proje ve laboratuvar çalışmalarıyla pekiştirme.',
  },
  {
    id: 6,
    title: 'YKS & Mezun Hazırlık',
    desc: 'Üniversiteye geçiş için kapsamlı deneme, konu tekrarı ve motivasyon seminerleri.',
  },
  {
    id: 7,
    title: 'Özel Dersler',
    desc: 'Birebir uzman eğitmen desteği ile kişiye özel hızda çalışma imkânı.',
  },
  {
    id: 8,
    title: 'Deneme Kulübü',
    desc: 'Düzenli deneme sınavları, istatistik takibi ve strateji güncelleme toplantıları.',
  },
  {
    id: 9,
    title: 'Cafe & Kütüphane',
    desc: 'Rahat çalışma ortamı, ücretsiz atıştırmalık ve zengin kaynak kütüphanesi.',
  },
];

export default function ServicesSection() {
  return (
    <section id="services-section" className="services-section">
      <h2>VIP Kurs ve Diğer Programlar</h2>
      <div className="services-grid">
        {services.map(s => (
          <div key={s.id} className="service-item">
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
